import React from 'react';
import './Button.css';

function Spinner() {
  return (
    <svg className="ui-btn__spinner" viewBox="0 0 16 16" aria-hidden="true">
      <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeDasharray="30" strokeDashoffset="10" />
    </svg>
  );
}

function Button({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  fullWidth = false,
  iconLeft = null,
  iconRight = null,
  type = 'button',
  className = '',
  onClick,
  ...rest
}) {
  const classes = [
    'ui-btn',
    `ui-btn--${variant}`,
    `ui-btn--${size}`,
    fullWidth ? 'ui-btn--full' : '',
    loading ? 'ui-btn--loading' : '',
    className,
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (loading || disabled) return;
    if (onClick) onClick(e);
  };

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      onClick={handleClick}
      {...rest}
    >
      {loading && <span className="ui-btn__spinner-wrap" aria-hidden="true"><Spinner /></span>}
      {iconLeft && <span className={`ui-btn__icon${loading ? ' ui-btn__icon--hidden' : ''}`} aria-hidden={loading ? 'true' : undefined}>{iconLeft}</span>}
      <span className={`ui-btn__label${loading ? ' ui-btn__label--hidden' : ''}`}>{children}</span>
      {iconRight && <span className={`ui-btn__icon${loading ? ' ui-btn__icon--hidden' : ''}`} aria-hidden={loading ? 'true' : undefined}>{iconRight}</span>}
    </button>
  );
}

export default Button;
